import React from "react";
import { Modal } from "react-bootstrap";
import { ReactComponent as CloseIc } from "../../assets/svg/close-modal.svg";
import { ReactComponent as ArrowDownIc } from "../../assets/svg/arrow-down.svg";

const BankTransactionModal = ({
    show,
    onHide,
    editingId,
    formData,
    setFormData,
    errors,
    setErrors,
    bankListOptions,
    onSave,
    isSaving = false
}) => {
    const handleInputChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
        if (errors[field] || errors.general) {
            setErrors(prev => {
                const next = { ...prev };
                delete next[field];
                delete next.general;
                return next;
            });
        }
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            size="lg"
            className="new-transaction-modal"
        >
            <Modal.Header className="border-0 p-4 pb-0 position-relative">
                <h3 className="modal-title fw-bold fs-24">{editingId ? "Edit Transaction" : "New Transaction"}</h3>
                <div
                    className="close-btn-custom-import"
                    onClick={onHide}
                >
                    <CloseIc style={{ width: "16px" }} />
                </div>
            </Modal.Header>
            <Modal.Body className="p-4 pt-1">
                {errors.general && (
                    <div className="alert alert-danger py-2 px-3 fs-14 mb-3 d-flex align-items-center justify-content-between" role="alert">
                        <div className="d-flex align-items-center gap-2">
                            <span className="fs-16">⚠️</span>
                            <span>{errors.general}</span>
                        </div>
                        <button
                            type="button"
                            className="btn-close fs-12"
                            aria-label="Close"
                            onClick={() => setErrors(prev => {
                                const next = { ...prev };
                                delete next.general;
                                return next;
                            })}
                        ></button>
                    </div>
                )}

                <div className="bank-name-field-container mb-2">
                    <label className="fs-14 fw-600 mb-0">Bank Name <span className="text-danger">*</span></label>
                    <div className="input-group-custom">
                        <select
                            className={`form-select-custom w-100 ${errors.bank_id ? 'is-invalid' : ''}`}
                            value={formData.bank_id}
                            onChange={(e) => handleInputChange("bank_id", e.target.value)}
                        >
                            <option value="">Select Bank</option>
                            {bankListOptions.map((opt) => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </select>
                        <ArrowDownIc className="select-arrow" style={{ width: "12px" }} />
                    </div>
                    {errors.bank_id && <div className="invalid-feedback d-block">{errors.bank_id}</div>}
                </div>

                <div className="row mb-2">
                    <div className="col-4">
                        <label className="fs-14 fw-600 mb-1">Cheque Number</label>
                        <input
                            type="text"
                            className={`form-control-custom ${errors.cheque_number ? 'is-invalid' : ''}`}
                            placeholder="Enter here..."
                            value={formData.cheque_number || ""}
                            onChange={(e) => handleInputChange("cheque_number", e.target.value)}
                        />
                        {errors.cheque_number && <div className="invalid-feedback d-block">{errors.cheque_number}</div>}
                    </div>
                    <div className="col-4">
                        <label className="fs-14 fw-600 mb-1">Balance <span className="text-danger">*</span></label>
                        <input
                            type="text"
                            className={`form-control-custom ${errors.balance ? 'is-invalid' : ''}`}
                            placeholder="Enter amount.."
                            value={formData.balance || ""}
                            onChange={(e) => handleInputChange("balance", e.target.value)}
                        />
                        {errors.balance && <div className="invalid-feedback d-block">{errors.balance}</div>}
                    </div>
                    <div className="col-4">
                        <label className="fs-14 fw-600 mb-1">Spent Amount <span className="text-danger">*</span></label>
                        <input
                            type="text"
                            className={`form-control-custom ${errors.spent_amount ? 'is-invalid' : ''}`}
                            placeholder="Enter amount.."
                            value={formData.spent_amount || ""}
                            onChange={(e) => handleInputChange("spent_amount", e.target.value)}
                        />
                        {errors.spent_amount && <div className="invalid-feedback d-block">{errors.spent_amount}</div>}
                    </div>
                </div>

                <div className="row mb-2">
                    <div className="col-6">
                        <label className="fs-14 fw-600 mb-1">Transaction Date <span className="text-danger">*</span></label>
                        <div className="input-with-icon">
                            <input
                                type="date"
                                className={`form-control-custom w-100 ${errors.transaction_date ? 'is-invalid' : ''}`}
                                value={formData.transaction_date || ""}
                                onChange={(e) => handleInputChange("transaction_date", e.target.value)}
                            />
                        </div>
                        {errors.transaction_date && <div className="invalid-feedback d-block">{errors.transaction_date}</div>}
                    </div>
                    <div className="col-6">
                        <label className="fs-14 fw-600 mb-1">Value Date <span className="text-danger">*</span></label>
                        <div className="input-with-icon">
                            <input
                                type="date"
                                className={`form-control-custom w-100 ${errors.value_date ? 'is-invalid' : ''}`}
                                value={formData.value_date || ""}
                                onChange={(e) => handleInputChange("value_date", e.target.value)}
                            />
                        </div>
                        {errors.value_date && <div className="invalid-feedback d-block">{errors.value_date}</div>}
                    </div>
                </div>

                <div className="mb-2">
                    <label className="fs-14 fw-600 mb-1">Description</label>
                    <input
                        type="text"
                        className={`form-control-custom w-100 ${errors.description ? 'is-invalid' : ''}`}
                        placeholder="Enter here..."
                        value={formData.description || ""}
                        onChange={(e) => handleInputChange("description", e.target.value)}
                    />
                    {errors.description && <div className="invalid-feedback d-block">{errors.description}</div>}
                </div>

                <div className="mb-2">
                    <label className="fs-14 fw-600 mb-1">Remarks</label>
                    <textarea
                        className={`form-control-custom w-100 ${errors.remarks ? 'is-invalid' : ''}`}
                        rows={3}
                        placeholder="Enter here..."
                        value={formData.remarks || ""}
                        onChange={(e) => handleInputChange("remarks", e.target.value)}
                    ></textarea>
                    {errors.remarks && <div className="invalid-feedback d-block">{errors.remarks}</div>}
                </div>
            </Modal.Body>
            <Modal.Footer className="border-0 p-4 pt-0 d-flex justify-content-end gap-3">
                <button
                    className="btn-cancel-custom-new"
                    onClick={onHide}
                    disabled={isSaving}
                >
                    Cancel
                </button>
                <button
                    className="btn-save-custom d-flex align-items-center gap-2"
                    onClick={onSave}
                    disabled={isSaving}
                >
                    {isSaving && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
                    {editingId ? "Update" : "Save"}
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default BankTransactionModal;
